import React from 'react';
import { useSelector } from 'react-redux';
import { useRetailerType } from '../../../hooks/useRetailerType';
import { CarrierDisplayName } from '../../../constants/carrierTypes';

import styles from './ShipperAccount.module.scss';

export function OperatorShipperAccount() {
  const { replenishment_shipper_account: account, replenishment_shipper_account_type: carrier } = useSelector(
    (state) => state.retailer.current ?? {},
  );

  const { isMarketplace } = useRetailerType();
  if (isMarketplace) return null;

  const hasShipperAccount = !!(carrier && account);

  return (
    <>
      <dt>Shipper Account:</dt>
      <dd>
        <div className={styles.shipperAccountContainer}>
          {hasShipperAccount ? (
            <span>
              <strong>{CarrierDisplayName[carrier]}</strong>: {account}
            </span>
          ) : (
            <span>None</span>
          )}
        </div>
      </dd>
    </>
  );
}
